import { websiteAdSenseEnabled } from "./ads";
import { isNativeApp } from "./nativeAds";
import { isEmbedded } from "./portal";
import { ADSENSE_CLIENT } from "./components/AdSenseUnit";

// Google AdSense on the website (playrafiki.com) only. Behind WEBSITE_ADSENSE_ENABLED (ads.ts).
//
// The AdSense loader used to sit in public/index.html for every build (app/strip-web-ads.js and
// tools/make-*.js strip it from the app and portal copies). It was taken out of the page when ads
// were switched off, so it is added here instead, from code, and only when AdSense is allowed:
// never in the apps (Google doesn't allow AdSense in apps; they use AdMob), never on portals or
// Discord (outside ads break their rules), and never while the flag is off.
export const adSenseAllowed = (): boolean => websiteAdSenseEnabled() && !isNativeApp() && !isEmbedded;

// Add the AdSense loader to the page once. Returns true if it is (now) on the page.
export const loadAdSense = (): boolean => {
  // Portal and Discord builds: decided at build time, so the AdSense address isn't even in
  // their code (some portals check games for outside ad networks).
  if (process.env.REACT_APP_PORTAL) return false;
  if (!adSenseAllowed() || typeof document === "undefined") return false;
  try {
    if (document.querySelector('script[src*="adsbygoogle.js"]')) return true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
    s.crossOrigin = "anonymous";
    document.head.appendChild(s);
    return true;
  } catch (e) {
    // Ads must never break the game.
    return false;
  }
};
